<template>
  <div class="configuration-sidebar ap-sidebar">
    <div class="ap-sidebar__header">
      <b-row class="py-2 w-100 m-0">
        <b-col
          cols="auto"
          class="d-flex pl-3 pr-0"
        >
          <div class="align-self-center">
            <div>
              <span
                class="ap-sidebar__title font-weight--medium m-0"
              >
                {{ $t('configuration.layout.configurationTitle') }}
              </span>
            </div>
          </div>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-end pr-2">
          <div class="icon-wrapper-main white">
            <i
              class="fal fa-cog mr-2"
              aria-hidden="true"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      v-testing="`header-${sideBarOptions.id}`"
      class="section-header p-2 text-center main"
    >
      <b-col>{{ sideBarOptions.title }}</b-col>
    </div>
    <div class="scroll-sidebar">
      <b-nav
        class="top-menu"
        vertical
      >
        <!-- TODO: Front debe echarle un vistazo para ver si se puede hacer mejor -->
        <div
          v-for="sidebar in sideBarOptions.sidebar"
          :key="sidebar.id"
        >
          <div
            v-if="!sidebar.hasChildren"
            class="selector"
          >
            <b-nav-item
              class="option-nav"
              :active="active(sidebar)"
              @click="goToSection(sidebar.routeName, sidebar.routeParams)"
            >
              <div class="icon-box d-flex align-items-center justify-content-center">
                <div class="icon-wrapper d-flex align-items-center justify-content-center">
                  <i
                    :class="sidebar.icon"
                    aria-hidden="true"
                  />
                </div>
              </div>
              <div style="width: 140px;">
                <span class="link-label">{{ sidebar.label }}</span>
              </div>
            </b-nav-item>
          </div>
          <div v-if="sidebar.hasChildren">
            <div>
              <b-nav-item
                v-b-toggle="sidebar.id + '-controls'"
                class="option-nav"
                @click="sidebar.active = !sidebar.active"
              >
                <div class="icon-box d-flex align-items-center justify-content-center">
                  <div class="icon-wrapper d-flex align-items-center justify-content-center">
                    <i
                      :class="sidebar.icon"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div style="width: 140px;">
                  <span class="option-label">{{ sidebar.label }}</span>
                </div>
                <div style="align-self: flex-start;margin-top:7px;">
                  <i
                    :class="[sidebar.active ? 'far fa-chevron-up' : 'far fa-chevron-down']"
                    aria-hidden="true"
                  />
                </div>
              </b-nav-item>
            </div>
            <b-collapse
              :id="sidebar.id + '-controls'"
              :visible="true"
            >
              <b-nav
                class="sub-menu-items"
                vertical
              >
                <div class="submenu-links">
                  <div
                    v-for="children in sidebar.children"
                    :key="children.id"
                  >
                    <b-nav-item
                      class="option-nav"
                      :active="active(children) && visible"
                      @click="goToSection(children.routeName, children.routeParams)"
                    >
                      <div class="icon-box d-flex align-items-center justify-content-center">
                        <div class="icon-wrapper d-flex align-items-center justify-content-center">
                          <i
                            class="submenu-icon far fa-circle"
                            aria-hidden="true"
                          />
                        </div>
                      </div>
                      <div style="width: 140px;">
                        <span class="option-label">{{ children.label }}</span>
                      </div>
                    </b-nav-item>
                  </div>
                </div>
              </b-nav>
            </b-collapse>
          </div>
        </div>
        <!-- TODO: El elemento de menú Padre con hijos tiene de momento un "d-none" hasta darle funcionalidad -->
        <div class="d-none">
          <div class="selector">
            <div>
              <b-nav-item
                :id="`navItem-12`"
                class="option-nav"
                :aria-controls="`statusCollapse-12`"
                :aria-expanded="visible ? 'true' : 'false'"
                @click="toggle"
              >
                <div class="icon-box d-flex align-items-center justify-content-center">
                  <div class="icon-wrapper d-flex align-items-center justify-content-center">
                    <i
                      class="far fa-circle"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div style="width: 140px;">
                  <span class="option-label">Prueba padre</span>
                </div>
                <div style="align-self: flex-start;margin-top:7px;">
                  <fa-icon
                    class="arrow-menu"
                    :icon="chevron"
                  />
                </div>
              </b-nav-item>
            </div>
          </div>
          <b-collapse
            :id="`statusCollapse-12`"
            v-model="visible"
          >
            <b-nav
              class="sub-menu-items"
              vertical
            >
              <div class="submenu-links">
                <b-nav-item class="option-nav">
                  <div class="icon-box d-flex align-items-center justify-content-center">
                    <div class="icon-wrapper d-flex align-items-center justify-content-center">
                      <i
                        class="submenu-icon far fa-circle"
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                  <div style="width: 140px;">
                    <span class="option-label">Prueba elemento</span>
                  </div>
                </b-nav-item>
                <b-nav-item class="option-nav">
                  <div class="icon-box d-flex align-items-center justify-content-center">
                    <div class="icon-wrapper d-flex align-items-center justify-content-center">
                      <i
                        class="submenu-icon far fa-circle"
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                  <div style="width: 140px;">
                    <span class="option-label">Prueba elemento</span>
                  </div>
                </b-nav-item>
              </div>
            </b-nav>
          </b-collapse>
        </div>
      </b-nav>
    </div>
  </div>
</template>

<script>
import { isNil } from 'lodash'

export default {
    name: 'ConfigurationSidebar',
    props: {
        sideBarOptions: Object
    },
    data() {
        return {
            visible: true,
            activeElement: true
        }
    },
    computed: {
        chevron() {
            return this.visible ? ['fal', 'chevron-up'] : ['fal', 'chevron-down']
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible
        },
        goToSection(name, params) {
            this.$router.push({ name, params })
        },
        active(sidebar) {
            if (!isNil(sidebar.selected)) {
                return sidebar.selected
            }
            return sidebar.routeName === this.$route.name
        }
    }
}

</script>

<style lang="scss" scoped>

.configuration-sidebar {
    display: flex;
    flex-direction: column;
    width: 218px;
    height: 100%;
    min-height: 0;
    -webkit-box-shadow: 1px 0px 5px 0px vt-color(sidebar-box-shadow);
    -moz-box-shadow: 1px 0px 5px 0px vt-color(sidebar-box-shadow);
    box-shadow: 1px 0px 5px 0px vt-color(sidebar-box-shadow);
    ::v-deep .nav-link {
        box-sizing: border-box;
        display: flex;
        padding-right: .2rem;
        align-items: center;
        color: $base-text-color;
        color: vt-color(sidebar-child-font) !important;
        font-weight:normal;
    }
}

.configuration-sidebar .top-menu {
  flex: 0 0 auto;
    ::v-deep .nav-link {
    padding: {
      right: .7rem;
      left: .5rem;
      top: .1rem;
      bottom: .1rem;
    }
    &.active {
      color: vt-color(white-light);
      background-color: vt-color(sidebar-element-actived);
    }
    &:hover {
      color: vt-color(primary);
    }
  }
}

.configuration-sidebar .selector:hover{
  background: vt-color(sidebar-single-element-hover);
}

.configuration-sidebar .icon-box {
    width: 32px;
    height: 32px;
    margin-right: 7px;
    align-self: flex-start;
}

.configuration-sidebar .option-label {
    align-self: flex-start;
}

.configuration-sidebar .option-nav .nav-link div:nth-child(2) {
   margin: 6px 0;
   margin-right: 5px;
}

.configuration-sidebar .menu-module {
  display: flex;
  align-items: center;
}

.configuration-sidebar .menu-main-title h4{
  font-size:1.1rem;
  font-weight: normal;
}

.configuration-sidebar .menu-main-title small{
  font-size:0.7rem;
  text-transform: uppercase;
}

.configuration-sidebar .menu-main-title{
  line-height: 0.9rem;
}

.configuration-sidebar .menu-module {
  display: flex;
  align-items: center;
}

.configuration-sidebar .section-pd{
  width:100%;
  margin:0;
}

.configuration-sidebar .icon-wrapper-main{
  font-size:1.6rem;
}

.configuration-sidebar .section-header{
  text-transform: uppercase;
  font-size:0.9rem;
  background: vt-color(sidebar-section-header-bg);
  color: vt-color(sidebar-section-header-text);
}

.configuration-sidebar .sub-menu-items {
    ::v-deep .nav-link {
    position: relative;
    &:hover {
      background-color: vt-color(sidebar-submenu-bg-hover);
    }
    &.active {
      color: vt-color(white-light) !important;
      background: vt-color(primary) !important;
      &::before {
        content: "";
        position: absolute;
        height: 100%;
        width: 3px;
        left: -7px;
        background-color: vt-color(black);
      }
    }
  }
}

.configuration-sidebar .nav-link span{
    font-size: 0.9rem;
  }

.configuration-sidebar .sub-menu-items{
  background:vt-color(sidebar-childs-bg);
}

.configuration-sidebar .submenu-icon {
    font-size: 0.7rem;
}

.configuration-sidebar .scroll-sidebar {
    overflow-y: auto;
    flex-grow: 1;
}

@media (max-width: 1300px){

  .configuration-sidebar .link-label{
    font-size: 0.9rem;
  }

  .configuration-sidebar .icon-wrapper{
    font-size: 1.1rem;
  }

  .configuration-sidebar .section-header{
    font-size:0.8rem;
  }

  .configuration-sidebar .menu-main-title h4{
    font-size:1rem;
  }

  .configuration-sidebar .menu-main-title small{
    font-size:0.65rem;
  }

  .configuration-sidebar .menu-main-title{
    line-height: 0.9rem;
  }

  .configuration-sidebar .icon-wrapper-main{
  font-size:1.4rem;
}

  .configuration-sidebar .nav-link span{
    font-size: 0.9rem;
  }

  .configuration-sidebar .nav-item.option-nav{
    font-size: 0.9rem;
  }
}

</style>
